import React from 'react'
import { Box, styled } from '@mui/material'

const Card = styled(Box)({
  background: 'var(--ds-canvas)',
  borderRadius: 'var(--ds-radius-lg)',
  boxShadow: 'var(--ds-shadow-soft)',
  padding: '22px 24px',
})

const Heading = styled(Box)({
  fontFamily: 'var(--ds-font-mono)',
  fontSize: 12,
  fontWeight: 700,
  letterSpacing: '0.1em',
  textTransform: 'uppercase',
  color: 'var(--ds-ink-subtle)',
  marginBottom: 14,
})

const Item = styled(Box)({
  display: 'flex',
  gap: 10,
  fontSize: 12.5,
  color: 'var(--ds-ink-muted)',
  padding: '8px 0',
  borderTop: '1px solid var(--ds-border)',
  '&:first-of-type': { borderTop: 'none', paddingTop: 0 },
})

const Dot = styled('span')({
  width: 6,
  height: 6,
  borderRadius: '50%',
  marginTop: 5,
  flexShrink: 0,
})

const Time = styled('span')({
  marginLeft: 'auto',
  fontSize: 10.5,
  color: 'var(--ds-ink-subtle)',
  whiteSpace: 'nowrap',
  paddingLeft: 10,
})

export interface ActivityPulseItem {
  id: string
  dotColor: string
  text: React.ReactNode
  timeAgo: React.ReactNode
}

export interface ActivityPulseCardProps {
  items: ActivityPulseItem[]
}

/** Renders null when there's no activity feed data yet. */
export function ActivityPulseCard({ items }: ActivityPulseCardProps) {
  if (!items.length) return null

  return (
    <Card>
      <Heading>Recent Activity</Heading>
      {items.map((item) => (
        <Item key={item.id}>
          <Dot sx={{ background: item.dotColor }} />
          {item.text}
          <Time>{item.timeAgo}</Time>
        </Item>
      ))}
    </Card>
  )
}
